import type { AppModule } from '@/app/app-module.types';
import { FileIcon } from '@/shared/icons';
import { FILES_ROLES } from '@/shared/guards/roles';
import { filesContainer } from './di/container';
import { FilesRepositoryToken } from './di/tokens';
import { filesRoutes } from './presentation/routes';

/**
 * Gerenciador de arquivos: inventário, custo, detalhe, force-delete e legal
 * hold sobre o registro global (`files` no monolith). Ver
 * docs/reference/modules/files.md § Gerenciador admin.
 */
export const filesModule: AppModule = {
  name: 'files',

  register(container) {
    container.register(FilesRepositoryToken, () => filesContainer.repository);
  },

  routes: filesRoutes,

  menu: [
    {
      label: 'Arquivos',
      to: '/files',
      icon: FileIcon,
      // Decisão 9 do épico files-admin.
      section: 'operations',
      order: 5,
      roles: FILES_ROLES,
    },
  ],
};
